import * as React from "react";
import {
  Stack,
  IStackTokens,
  DefaultButton,
  PrimaryButton,
  Toggle,
} from "office-ui-fabric-react";
import CustomDrawer from "../../common/CustomDrawer";
import { ISMPSReading } from "../../../vm";
import { Formik } from "formik";
import { updateSmpsReading } from "../../../services/infrastructure/SmpsService";
import { ToastContext } from "../../common/ToastProvider";
import { getAlertDetails } from "../../../services/ThresholdService";
import { ConfirmDialogContext } from "../../common/ConfirmDialogProvider";
import { CustomTextField } from "../../common/Library";
import * as yup from "yup";

const smpsReadingSchema = yup.object().shape({
  dcVolt: yup.number().required("Required"),
  dcAmps: yup.number().required("Required"),
  roomTemp: yup.number().required("Required"),
  recordedBy: yup.string().required("Required"),
  remarks: yup.string().optional(),
});

export interface ManageSmpsDialogProps {
  data?: ISMPSReading;
  closeManageDialog: any;
  handleLoading: any;
  threshold: any;
}

const ManageSmpsDialog: React.FC<ManageSmpsDialogProps> = ({
  data,
  handleLoading,
  closeManageDialog,
  threshold,
}) => {
  //state
  const [state, setState] = React.useState({
    smpsReading: {
      ...data,
    },
    isLoading: false,
  } as {
    smpsReading: ISMPSReading;
    isLoading: boolean;
  });

  //hooks
  const { showToast } = React.useContext(ToastContext);
  const { showConfirmDialog } = React.useContext(ConfirmDialogContext);

  const wrapStackTokens: IStackTokens = { childrenGap: 8 };
  const closeAddDialog = (data?: ISMPSReading) => {
    closeManageDialog(data);
  };
  const onBlurFunc = (value: any, path: string) => {
    // console.log("onBlurFunc");
    const { showAlert, msg } = getAlertDetails(path, threshold, value);
    // console.log("[showAlert]", showAlert, msg);
    if (showAlert === true) {
      showConfirmDialog("Alert", msg as string, () => {}, "Ok", true);
    }
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title={"Update SMPS Reading"}
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.smpsReading}
            // validationSchema={smpsReadingSchema}
            onSubmit={async (values: ISMPSReading, { setSubmitting }) => {
              let obj = { ...values };
              let result;
              handleLoading();
              result = await updateSmpsReading(obj);
              handleLoading();
              if (result?.success) {
                closeAddDialog(result.data);
                showToast(`SMPS Reading updated successfully`, "success");
              } else {
                showToast(`Error while updating an smps reading`, "error");
              }
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={wrapStackTokens}>
                  <Stack.Item className="custom-toggle">
                    <Toggle
                      checked={values.isSystemOn}
                      label="System"
                      onText="On"
                      offText="Off"
                      onChange={(e, v) => {
                        setFieldValue("isSystemOn", v);
                      }}
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <CustomTextField
                      name="dcVolt"
                      label={"DC Volt"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <CustomTextField
                      name="dcAmps"
                      label={"DC Amps"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <CustomTextField
                      name="roomTemp"
                      label={"SMPS Room Temp °C"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                    />
                  </Stack.Item>
                  <Stack.Item>
                    <CustomTextField
                      name="batteryRoomTemp"
                      label={"Battery Room Temp °C"}
                      onBlurFunc={onBlurFunc}
                      type="number"
                    />
                  </Stack.Item>

                  <Stack.Item>
                    <CustomTextField
                      name="remarks"
                      label={"Remarks"}
                      onBlurFunc={onBlurFunc}
                    />
                  </Stack.Item>
                  <Stack.Item className="pt-24">
                    <CustomTextField
                      name="recordedBy"
                      label={"Shift Tech Sign"}
                      onBlurFunc={onBlurFunc}
                      disabled
                    />
                  </Stack.Item>
                  <br />
                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={wrapStackTokens}
                      horizontalAlign="end"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text="Update" />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
      </CustomDrawer>
    </React.Fragment>
  );
};

// export const THRESHOLD = {
//   dcVolt: {
//     type: "range",
//     min: 53,
//     max: 55,
//   },
//   dcAmps: {
//     type: "lessThan",
//     value: 50,
//   },
// }

export default ManageSmpsDialog;
